import { useQuery } from '@tanstack/react-query'

import { fetchBackendJson } from './backend/api'

// The backend snapshots prices every 15 minutes and caches the chart for 5.
const STALE_MS = 5 * 60_000

export type TokenChart = {
  /** [unix ms, USD price], oldest first. */
  points: [number, number][]
  priceChange24h: number | null
  volume24h: number | null
  liquidity: number | null
  statsSource: 'coingecko' | 'dexscreener' | null
}

export function useTokenChart(chainId: number | undefined, address: string | undefined) {
  return useQuery({
    queryKey: ['tokenChart', chainId, address?.toLowerCase()],
    queryFn: () =>
      fetchBackendJson<TokenChart>(`/token-list/chart?chainId=${chainId}&address=${address?.toLowerCase()}`),
    enabled: Boolean(chainId && address),
    staleTime: STALE_MS,
    // Hover-triggered: a failure just hides the card, retries would only add load.
    retry: false,
  })
}
